import type { ComponentProps } from "react";

import CrmEnrichmentJobNameModal from "../../../components/CrmEnrichmentJobNameModal/CrmEnrichmentJobNameModal";
import { useCrmEnrichmentContext } from "../../../contexts/CrmEnrichmentContext";
import { useJobNameModalState } from "../../../hooks/useJobNameModalState";

type Props = Pick<ComponentProps<typeof CrmEnrichmentJobNameModal>, "isSubmitLoading" | "onSaveName"> & {
    initialJobName?: string;
};

const CrmEnrichmentJobNameModalContainer = ({ initialJobName, isSubmitLoading, onSaveName }: Props) => {
    const { crmProvider } = useCrmEnrichmentContext();

    const { isNameModalOpen, jobName, onSetJobName, onNameModalTrigger } = useJobNameModalState(initialJobName);

    const handleCloseModal = () => {
        onNameModalTrigger(false);
    };

    return (
        <CrmEnrichmentJobNameModal
            isSubmitLoading={isSubmitLoading}
            crmProvider={crmProvider}
            jobName={jobName}
            isOpened={isNameModalOpen}
            isSubmitDisabled={!jobName.trim() || jobName === initialJobName}
            onSaveName={onSaveName}
            onChangeJobName={onSetJobName}
            onClose={handleCloseModal}
        />
    );
};

export default CrmEnrichmentJobNameModalContainer;
